import {isEmpty} from 'lodash';
import {Resolve} from '@angular/router';
import {Injectable} from '@angular/core';
import {Keys, StorageService} from '../service/storage.service';
import {LoanDetailsService} from '../service/loan-details.service';
import {UserService} from '../service/user.service';

@Injectable()
export class LoanResidenceInfoResolver implements Resolve<{ proofType: string, proofNumber: string } | null> {
    private readonly storageService: StorageService;
    private readonly loanDetailsService: LoanDetailsService;
    private userService: UserService;

    constructor(storageService: StorageService, loanDetailsService: LoanDetailsService, userService: UserService) {
        this.storageService = storageService;
        this.loanDetailsService = loanDetailsService;
        this.userService = userService;
    }

    public async resolve(): Promise<{ proofType: string, proofNumber: string, aadhaarLinkedWithMobile: boolean } | null> {
        const loanId = this.storageService.getItem(Keys.LOAN_ID);
        const userId = this.storageService.getItem(Keys.PROFILE_ID);
        const response = await this.loanDetailsService.getLoanDetails(loanId);
        const profileDetails = await this.userService.getProfileDetails(userId);
        const loan = response.loan_info;
        if (isEmpty(loan.correspondence_address) || isEmpty(loan.correspondence_address.proofs)) {
            return null;
        }

        return {
            proofType: loan.correspondence_address.proofs[0].proofType,
            proofNumber: loan.correspondence_address.proofs[0].proofNumber,
            aadhaarLinkedWithMobile: profileDetails.aadhaarLinkedWithMobile
        };
    }
}
